/* eslint-disable */
import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-webpack-loader-syntax
import videojs from '!video.js';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import TR from './../../Trans';
import TopBarPlayer from './TopBarPlayer';
import BottomBarPlayer from './BottomBarPlayer';
import { VideoPlayer } from './VideoPlayer';
import ExternalInfo from './ExternalInfo';
import { Capacitor } from '@capacitor/core';
import OnTop from './OnTop';
import { useSessionStorage } from 'usehooks-ts';
import { getPlatform, isPossiblyIPad, isIPhone, isChromecast } from './../../services/os';
import sessionStore from './../../stores/session';
import playerStore from './../../stores/player';
import performanceStore from '../../stores/performance';
import newTracksStore from './../../stores/newTracks';
import accountStore from '../../stores/account';
import testStore from '../../stores/test';
import settingsStore from '../../stores/settings';
import MarqueeBarPlayer from './MarqueeBarPlayer';
import ExternalPlayer from './ExternalPlayer';
import musicPlayerStore from '../../stores/musicPlayer';
import navigationStore from '../../stores/navigation';
import CurrentTime from './CurrentTime';

var timeUpdateInterval = null;
var playTimeout = null;
const bgImageTemplate = "https://player.muvika.com/graphics/images/ext-screen/ext-screen-bg-";


function ExternalView(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const isFocused = playerStore((state) => state.isFocused);
  const setIsFocused = playerStore((state) => state.setIsFocused);
  const countdown = performanceStore((state) => state.countdown);
  //const currentTime = playerStore((state) => state.currentTime);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const playQueue = performanceStore((state) => state.playQueue);
  const newTracks = newTracksStore((state) => state.tracks);
  const isStopped = playerStore((state) => state.isStopped);
  const account = accountStore((state) => state.account);
  const getAccount = accountStore((state) => state.getAccount);
  const latest = newTracksStore((state) => state.latest);
  const getLatest = newTracksStore((state) => state.getLatest);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const urls = accountStore((state) => state.urls);
  const streamUrl = playerStore((state) => state.streamUrl);
  const isPlaying = playerStore((state) => state.isPlaying);
  const from = playerStore((state) => state.from);
  const currentVolume = playerStore((state) => state.currentVolume);
  const playQueueTrackList = performanceStore((state) => state.playQueueTrackList);
  const currentTitle = performanceStore((state) => state.currentTitle);
  const nextSingerTitle = performanceStore((state) => state.nextSingerTitle);
  const newTracksTitle = newTracksStore((state) => state.newTracksTitle);
  const isInExternalWindow = playerStore((state) => state.isInExternalWindow);
  const refreshToken = sessionStore((state) => state.refreshToken);
  const isMusicOn = musicPlayerStore((state) => state.isMusicOn);
  const isApiWindowPerm = sessionStore((state) => state.isApiWindowPerm);
  const rollExternalViewBgIndex = navigationStore((state) => state.rollExternalViewBgIndex);
  const iosFrom = playerStore((state) => state.iosFrom);
  const isMusicReallyPaused = musicPlayerStore((state) => state.isMusicReallyPaused);

  const [isCustomer, setIsCustomer] = useState(false);
  const [isSongBookEnabled, setIsSongBookEnabled] = useState(false);
  const [numSingers, setNumSingers] = useState(0);
  const [isOnAutoPlay, setIsOnAutoPlay] = useState(false);
  const [autoPlaySecs, setAutoPlaySecs] = useState(0);
  const [songBookStr, setSongBookStr] = useState("");
  const [songBookUrl, setSongBookUrl] = useState("");
  const [isBuffering, setIsBuffering] = useState(false);

  const [iniFrom, setIniFrom] = useState(null);

  useEffect(() => {
    if (!newTracks) {
      getLatest(sessionToken, 50);
    }
    if (!account) {
      getAccount(sessionToken);
    }
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  useEffect(() => {
    if (account) {
      setIsCustomer(account.tags.includes("consumer"));
      TR.setLanguage(account.language.toLowerCase());
      document.title = TR.ww_page_title;
    }
  }, [account]);

  const getPlainSongbookUrl = () => {
    if (urls) {
      let url = urls.url_songbook;
      let urlSplitted = url.split(".");
      if (urlSplitted.length > 2) {
        return urlSplitted[urlSplitted.length - 2] + "." + urlSplitted[urlSplitted.length - 1];
      } else {
        let urlSplitted = url.split("://");
        if (urlSplitted.length == 2) {
          return urlSplitted[1];
        }
      }
    }
    return "";
  };

  useEffect(() => {
    if (account) {
      setSongBookUrl(getPlainSongbookUrl());
    }
  }, [urls]);

  useEffect(() => {
    if (settings) {
      setIsSongBookEnabled(settings.sb_enabled == 1);
      setNumSingers(settings.num_singers_shown);
      setIsOnAutoPlay(settings.autoplay_enabled == 1);
      setAutoPlaySecs(settings.autoplay_enabled == 1 ? settings.autoplay_secs : 0);
      setSongBookStr(settings.sb_code);
    }
  }, [settings]);

  /*   useEffect(() => { 
      if (!props.isDesktop) {
        const player = videojs('muvika-ios-external-player');
        if (player) {
          if (Math.abs(player.currentTime() - previewCurrentTime) > 1) {
            player.currentTime(previewCurrentTime);
          }
        }
      }
    }, [previewCurrentTime]);
   */

  const videoJsOptions = {
    autoplay: false,
    controls: false,
    poster: null,
    controlBar: {
      pictureInPictureToggle: false
    },
    responsive: false,
    fluid: false,
    width: "100%",
    height: "100%",
  };

  const fixIPadScaling = () => {
    if (isPossiblyIPad()) {
      let videoElement = document.getElementsByTagName("video");
      var playerElement = document.getElementById("muvika-ios-external-player");
      if (videoElement.length > 0 && playerElement) {
        var width = videoElement[0].videoWidth;
        var height = videoElement[0].videoHeight;
        var aspectRatio = width / height;
        var playerHeight = playerElement.offsetHeight;
        videoElement[0].style.transform = "scaleX(" + ((playerStore.getState().iosExternalScreenWidth / playerHeight) / aspectRatio) + ")";
      }
    }
  };

  const sendTimeupdate = () => {
    let player = videojs('muvika-ios-external-player');
    if (player) {
      if (isPossiblyIPad() || isIPhone()) {
        window.webkit.messageHandlers.Muvika.postMessage({
          currentTime: player.currentTime()
        });
      }
      if (Muvika) {
        Muvika.sendCurrentTime(player.currentTime());
      }
    }
  };

  const setStreamUrl = (streamUrl) => {
    let player = videojs('muvika-ios-external-player');
    if (player) {
      player.playsinline(true);
      player.on('loadstart', () => {
        if (isPossiblyIPad() || isIPhone()) {
          window.webkit.messageHandlers.Muvika.postMessage({
            isBuffering: true
          });
        }
        if (Muvika) {
          Muvika.sendIsBuffering(true);
        }
      });
      player.on('canplay', () => {
        if (isPossiblyIPad() || isIPhone()) {
          window.webkit.messageHandlers.Muvika.postMessage({
            isBuffering: false
          });
        }
        if (Muvika) {
          Muvika.sendIsBuffering(false);
        }
      });
      player.src(streamUrl);
      if (!isPossiblyIPad() && !isIPhone()) {
        player.currentTime(playerStore.getState().currentTime);
      }
      player.load();
      if (timeUpdateInterval) {
        clearInterval(timeUpdateInterval);
      }
      timeUpdateInterval = setInterval(sendTimeupdate, 500);
      /* player.on('timeupdate', () => { 
        if (isPossiblyIPad() || isIPhone()) {
          window.webkit.messageHandlers.Muvika.postMessage({
            currentTime: player.currentTime()
          });
        }
        if (Muvika) {
          Muvika.sendCurrentTime(player.currentTime());
        }
      }); */
      player.one('timeupdate', function () {
        if (isPossiblyIPad() || isIPhone()) {
          if (playerStore.getState().iosFrom?.from && playerStore.getState().iosFrom?.from != 0) {
            console.log("set iosFrom from", playerStore.getState().iosFrom.from);
            setCurrentTime(playerStore.getState().iosFrom.from);
            player.currentTime(playerStore.getState().iosFrom.from);
            playerStore.getState().setIosFrom(null);
          }
        } else {
          playerStore.getState().setIosFrom(null);
        }
      });
      player.on('playing', () => {
        //fixIPadScaling();
      });
      setTimeout(function () {
        if (!props.isDesktop && isMusicOn) {
          if (playTimeout) {
            clearTimeout(playTimeout);
          }
          if (playerStore.getState().isPlaying.isPlaying && musicPlayerStore.getState().isMusicReallyPaused.isPaused) {
            player.play();
          } else {
            player.pause();
          }
        } else {
          if (playerStore.getState().isPlaying.isPlaying) {
            player.play();
          } else {
            player.pause();
          }
        }
      }, 100);
    }
  };

  const play = () => {
    let player = videojs('muvika-ios-external-player');
    if (player) {
      player.play();
    }
  };

  const pause = () => {
    let player = videojs('muvika-ios-external-player');
    if (player) {
      clearTimeout(playTimeout);
      player.pause();
    }
  };

  const stop = () => {
    let player = videojs('muvika-ios-external-player');
    if (player) {
      if (playTimeout) {
        clearTimeout(playTimeout);
      }
      player.pause();
      setCurrentTime(0);
      player.currentTime(0);
    }
  };

  const setFromTime = (time) => {
    let player = videojs('muvika-ios-external-player');
    if (player) {
      if (isPlaying.isPlaying && musicPlayerStore.getState().isMusicReallyPaused.isPaused) {
        player.play();
      } else {
        player.pause();
      }
      setCurrentTime(time);
      player.currentTime(time);
    }
  };

  useEffect(() => {
    if (!props.isDesktop) {
      setFromTime(from.from);
    }
  }, [from]);

  useEffect(() => {
    if (!props.isDesktop) {
      let player = videojs('muvika-ios-external-player');
      if (player) {
        if (isPlaying.isPlaying && isMusicReallyPaused.isPaused) {
          player.play();
        }
      }
    }
  }, [isMusicReallyPaused]);

  useEffect(() => {
    if (!props.isDesktop) {
      if (streamUrl) {
        if (streamUrl !== "") {
          setStreamUrl(streamUrl);
        }
      }
    }
  }, [streamUrl]);

  const handlePlay = (isPlaying) => {
    if (!props.isDesktop) {
      let player = videojs('muvika-ios-external-player');
      if (player) {
        if (isMusicOn) {
          if (playTimeout) {
            clearTimeout(playTimeout);
          }
          if (playerStore.getState().isPlaying.isPlaying && musicPlayerStore.getState().isMusicReallyPaused.isPaused) {
            player.play();
          } else {
            player.pause();
          }
        } else {
          if (isPlaying.isPlaying) {
            play();
          } else {
            pause();
          }
        }
      }
    }
  };

  useEffect(() => {
    if (isMusicOn == false) {
      if (playTimeout) {
        clearTimeout(playTimeout);
      }
    }
  }, [isMusicOn]);

  useEffect(() => {
    handlePlay(isPlaying);
  }, [isPlaying]);

  useEffect(() => {
    if (!props.isDesktop) {
      if (isStopped.isStopped) {
        stop();
      }
    }
  }, [isStopped]);

  const setPlayerVolume = (volume) => {
    let player = videojs('muvika-ios-external-player');
    if (player) {
      player.volume(volume);
    }
  };

  useEffect(() => {
    if (currentVolume.currentVolume) {
      if (!props.isDesktop) {
        if (!currentVolume.doNotPropagate) {
          setPlayerVolume(currentVolume.currentVolume);
        }
      }
    }
  }, [currentVolume]);

  const getBackgroundImage = () => {
    let index = navigationStore.getState().externalViewBgIndex;
    let fileEnding = index + ".jpg";
    return "url('" + bgImageTemplate + "" + fileEnding + "')";
  };

  const renderOnTop = () => {
    let height = (isCustomer || isSongBookEnabled) ? "89vh" : "95vh";
    let top = "6vh";
    if (isFocused) {
      if (nextPerformance) {
        return <OnTop
          style={{ height: height, width: "100%", zIndex: 99999, position: "fixed", top: top, backgroundImage: getBackgroundImage(), backgroundSize: "cover", backgroundColor: "black", overflow: "hidden" }}
          currentTitle={currentTitle ? currentTitle : ""}
          numSingers={numSingers}
          playQueue={playQueue}
          newTracksTitle={newTracksTitle}
          isOnAutoPlay={isOnAutoPlay}
          isCustomer={isCustomer}
        />;
      } else if (isStopped.isStopped) {
        return <OnTop
          style={{ height: height, width: "100%", zIndex: 99999, position: "fixed", top: top, backgroundImage: getBackgroundImage(), backgroundSize: "cover", backgroundColor: "black", overflow: "hidden" }}
          currentTitle={currentTitle ? currentTitle : ""}
          playQueue={playQueue}
          numSingers={numSingers}
          newTracksTitle={newTracksTitle}
          isOnAutoPlay={isOnAutoPlay}
          isCustomer={isCustomer}
        />;
      }
    } else {
      let fsText = TR.cm_press_f11_for_fullscreen_in_extscreen;
      if (isApiWindowPerm && isPossiblyIPad()) {
        fsText = TR.cm_mac_ipad_fullscreen;
      } else if (!isApiWindowPerm && isPossiblyIPad() && !isChromecast()) {
        fsText = TR.cm_mac_ipad_click_fullscreen;
      } else if (!isApiWindowPerm && !isPossiblyIPad() && !isChromecast()) {
        fsText = TR.cm_press_f11_in_video_window;
      } else if (!isApiWindowPerm && !isPossiblyIPad() && isChromecast()) {
        fsText = TR.cm_chromebook_fullscreen;
      }
      return <div style={{ height: height, width: "100%", textAlign: "center", zIndex: 99999, position: "fixed", top: top, background: "black" }}>
        <h4>{fsText}</h4>
      </div>;
    }
  };

  useEffect(() => {
    console.log("rendertest");
  }, [isCustomer, isSongBookEnabled, account, props.isDesktop]);

  const renderPlayer = () => {
    console.log("rendertest");
    let height = (isCustomer || isSongBookEnabled) ? "89vh" : "95vh";
    if (props.isDesktop) {
      return <ExternalPlayer
        style={{ height: height, width: "100%" }}
        options={{
          autoplay: false,
          controls: false,
          poster: null,
          controlBar: {
            pictureInPictureToggle: false
          },
          responsive: false,
          fluid: false,
          width: "100%",
          height: "100%",
        }}
        isCustomer={account ? account.tags.includes("consumer") : false}
      />;
    } else {
      return <div style={{ width: "100%", height: height }} >
        <video id="muvika-ios-external-player" className={"video-js vjs-default-skin"} preload="auto" playsInline fill style={{ width: "100%", height: "100%" }} poster="./poster.png">
        </video>
      </div>;
    }
  };

  const checkIpad = (platform) => {
    return ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'iPad'].includes(platform);
  };

  const renderTopBar = () => {
    return <MarqueeBarPlayer
      numSingers={numSingers}
      isCustomer={isCustomer}
      isStopped={isStopped.isStopped}
      isOnAutoPlay={isOnAutoPlay}
      currentTitle={currentTitle ? currentTitle : ""}
      nextSinger={nextSingerTitle ? nextSingerTitle : ""}
      playQueueTrackList={playQueueTrackList ? playQueueTrackList : ""}
      nextPerformance={nextPerformance}
      autoPlaySecs={autoPlaySecs}
      trackLength={currentPerformance ? currentPerformance.track.length.split(':').reduce((acc, time) => (60 * acc) + +time) : 0}
      countdown={countdown}
    />;
  };

  const renderBottomBar = () => {
    return <BottomBarPlayer
      isSongBookEnabled={isSongBookEnabled}
      isCustomer={isCustomer}
      songBookStr={songBookStr}
      songBookUrl={songBookUrl}
    />;
  };

  const renderInfo = () => {
    if (!props.isDesktop) {
      if (newTracksTitle == null) {
        return <ExternalInfo />;
      }
    }
  };

  const handleKeyDown = (event) => {
    setIsFocused(true);
  };

  return (
    <div onClick={() => {
      setIsFocused(true);
    }}
      onKeyDown={handleKeyDown}>

      {renderInfo()}

      {renderTopBar()}

      {renderPlayer()}

      {renderOnTop()}

      {renderBottomBar()}

    </div>
  );
}

export default ExternalView;